import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: flex;
  padding: 20px;
  border-top: 1px solid ${(p) => p.theme.greys.shade30};
`;

/*
 * Component.
 */

export const DialogFooter: FC<PropsWithChildren<unknown>> = ({children}) => (
  <StyledWrapperDiv>{children}</StyledWrapperDiv>
);
